import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';
import i18n from '@/i18n';
import { RootState } from '../interfaces/rootState';
import { httpCommpix, getAuthPayload } from '@/util/HTTPCommpix';
import {
  PayoutConfigurationResponse,
  PayoutConfigurationState,
  NewPayoutConfigurationRequest
} from '@/store/interfaces/commpix-api/payoutConfiguration';
import payoutConfigurationTypes from '@/store/types/payoutConfiguration';

const namespaced = true;

const state: PayoutConfigurationState = {
  configuration: null,
  error: null,
};

const mutations: MutationTree<PayoutConfigurationState> = {
  [payoutConfigurationTypes.mutations.SET_CONFIGURATION](state, configuration: PayoutConfigurationResponse | null) {
    state.configuration = configuration;
  },
  [payoutConfigurationTypes.mutations.SET_ERROR](state, error: string | null) {
    state.error = error;
  },
  [payoutConfigurationTypes.mutations.CLEAR_STATE](state) {
    state.configuration = null;
    state.error = null;
  },
};

const actions: ActionTree<PayoutConfigurationState, RootState> = {
  async [payoutConfigurationTypes.actions.FETCH_CONFIGURATION]({ commit, }): Promise<PayoutConfigurationResponse | null> {
    commit(payoutConfigurationTypes.mutations.CLEAR_STATE);
    try {
      const { companyId, commerceId, branchId, } = getAuthPayload();
      const response = await httpCommpix.get<PayoutConfigurationResponse>(
        `/payouts/configuration/${companyId}/${commerceId}/${branchId}`
      );
      commit(payoutConfigurationTypes.mutations.SET_CONFIGURATION, response.data);
      return response.data;
    } catch (error) {
      const message = i18n.t('pix.payoutsConfiguration.messages.loadError') as string;
      commit(payoutConfigurationTypes.mutations.SET_ERROR, message);
      return null;
    }
  },

  async [payoutConfigurationTypes.actions.CREATE_CONFIGURATION](
    { commit, },
    payload: NewPayoutConfigurationRequest
  ): Promise<PayoutConfigurationResponse> {
    commit(payoutConfigurationTypes.mutations.SET_ERROR, null);
    try {
      const response = await httpCommpix.post<PayoutConfigurationResponse>('/payouts/configuration', payload);
      commit(payoutConfigurationTypes.mutations.SET_CONFIGURATION, response.data);
      return response.data;
    } catch (error) {
      const message = i18n.t('pix.payoutsConfiguration.messages.saveError') as string;
      commit(payoutConfigurationTypes.mutations.SET_ERROR, message);
      return Promise.reject(message);
    }
  },
};

const getters: GetterTree<PayoutConfigurationState, RootState> = {
  [payoutConfigurationTypes.getters.GET_CONFIGURATION]: state => state.configuration,
  [payoutConfigurationTypes.getters.GET_ERROR]: state => state.error,
};

export const payoutConfiguration: Module<PayoutConfigurationState, RootState> = {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};

export default payoutConfiguration;
